import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "@reach/router";
import classNames from "classnames";
import { AppContext } from "~/scripts/context/app";

const PrevLink = ({ children, uri, onClick }) =>
    uri ? (
        <Link id="prev-director" to={`/${uri}`} state={{ transition: "prev" }} onClick={onClick}>
            {children}
        </Link>
    ) : (
        children
    );

PrevLink.propTypes = {
    children: PropTypes.node,
    uri: PropTypes.string,
    onClick: PropTypes.func,
};

class Previous extends Component {
    constructor(props){
        super(props);
        this.keyPress = this.keyPress.bind(this);
    }

    keyPress(event) {
        if (event.key == "ArrowLeft" && this.props.prev) {
            document.getElementById("prev-director").click();
        }
    }
    componentDidMount() {
        document.addEventListener("keydown", this.keyPress, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.keyPress, false);
    }

    static propTypes = {
        title: PropTypes.string,
        prev: PropTypes.shape({
            uri: PropTypes.string,
            onClick: PropTypes.func,
        })
    };

    static contextType = AppContext;

    render() {
        const { title, prev, toggleSpecialPageTransition } = this.props;
        const { theme } = this.context;

        return (
            <div className={classNames("previous", `theme-${theme}`)}>
                <PrevLink 
                    uri={prev && prev.uri} 
                    onClick={() => {toggleSpecialPageTransition(true, 'previous')}}
                >
                    <div
                        className={classNames("previous__title", {
                            hide: !prev
                        })}
                    >
                        Previous {title}
                    </div>
                </PrevLink>

                <div
                    className={classNames("previous__next next__title")}
                >
                    Next {title}
                </div>
            </div>
        );
    }
}

export default Previous;



// WEBPACK FOOTER //
// ./src/scripts/components/Previous.js